import CybsCard from '@cybs-ui/components/lib/card';
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadStaticRequestResponse,
  updateCurrentStage,
  updateIsChallengeCardChoosed
} from '../../redux/action/3ds-actions';
import './GifComponent.scss';

function GifComponent() {
  const [visibility, setVisibility] = useState('hidden');
  const [gifProps, setGifProps] = useState({ src: undefined, altText: undefined });
  const {
    runSequences,
    currentStage: currentStage,
    demoToolType: demoToolType
  } = useSelector((state) => state.runSeqReducer);
  const dispatch = useDispatch();
  const title = 'Checkout Demo Information';
  const hostUrl = window.location.host;
  let images = require.context('../../assets', true);
  const gifRootPath = hostUrl.includes('apihub.visa.com')
    ? 'https://developer.cas.cybersource.com/content/dam/cybsdeveloper2021/images/3ds-demo-tool/gif/'
    : '/content/dam/cybsdeveloper2021/images/3ds-demo-tool/gif/';
  const xfRootPath =
    hostUrl.includes('apihub.visa.com') || process.env.NODE_ENV === 'development'
      ? 'https://developer.cas.cybersource.com'
      : '';
  const gifStage = runSequences.find((sequence) => {
    if (
      sequence.stage === currentStage &&
      (sequence.stage === 2 || sequence.stage === 6) &&
      sequence.gifDisplay === false
    ) {
      return sequence;
    }
    return undefined;
  });
  useEffect(() => {
    if (gifStage !== undefined && gifStage.stage === 2 && gifStage.gifDisplay === false) {
      setVisibility('visible');
      let timer;
      if (gifStage.subStages[0].num === 1 && gifStage.subStages[0].disable === false) {
        const imgSrc =
          process.env.NODE_ENV === 'production'
            ? gifRootPath + `${gifStage.subStages[0].src}`
            : images('./' + gifStage.subStages[0].src).default;
        setGifProps({
          src: imgSrc,
          altText: 'An animated GIF to load Microform for card Type Challenge'
        });
        timer = setTimeout(() => {
          dispatch(
            loadStaticRequestResponse(
              2,
              gifStage.subStages[0].staticRequestResponsePath,
              xfRootPath,
              undefined,
              demoToolType
            )
          );
          dispatch(updateCurrentStage(3));
          dispatch(updateIsChallengeCardChoosed(true));
        }, gifStage.subStages[0].loadTime);
      } else if (gifStage.subStages[1].num === 2 && gifStage.subStages[1].disable === false) {
        const imgSrc =
          process.env.NODE_ENV === 'production'
            ? gifRootPath + `${gifStage.subStages[1].src}`
            : images('./' + gifStage.subStages[1].src).default;
        setGifProps({
          src: imgSrc,
          altText: 'An animated GIF to load Microform for card Type Frictionless'
        });
        timer = setTimeout(() => {
          dispatch(
            loadStaticRequestResponse(
              2,
              gifStage.subStages[1].staticRequestResponsePath,
              xfRootPath,
              undefined,
              demoToolType
            )
          );
          dispatch(updateCurrentStage(3));
        }, gifStage.subStages[1].loadTime);
      }
      return () => clearTimeout(timer);
    } else if (gifStage !== undefined && gifStage.stage === 6 && gifStage.gifDisplay === false) {
      setVisibility('visible');
      let timer;
      const imgSrc =
        process.env.NODE_ENV === 'production'
          ? gifRootPath + `${gifStage.src}`
          : images('./' + gifStage.src).default;
      setGifProps({
        src: imgSrc,
        altText: 'An animated GIF to load Microform for card Type Frictionless'
      });
      timer = setTimeout(() => {
        dispatch(
          loadStaticRequestResponse(
            6,
            gifStage.staticRequestResponsePath,
            xfRootPath,
            undefined,
            demoToolType
          )
        );
        dispatch(updateCurrentStage(7));
      }, gifStage.loadTime);
      return () => clearTimeout(timer);
    } else {
      setVisibility('hidden');
    }
  }, [gifStage]);

  return (
    <CybsCard
      className="parallel-card gif"
      dataTest="gif-card"
      header={<CybsActionBar dataTest="checkout-info-cardview" i18n={{ title }} />}
    >
      {visibility === 'visible' && (
        <img
          src={gifProps.src}
          alt={gifProps.altText}
          style={{ visibility, maxHeight: '100%', maxWidth: '100%' }}
        />
      )}
    </CybsCard>
  );
}

export default GifComponent;
